import WomanCard from "../../Home/Components/WomanCard/WomanCard";
import { getWomanThumbImageUrl } from "../../../utils/imageUrl";
import { useTranslation } from "../../../i18n/LanguageProvider";

function RandomWomenSection({ women, loading }) {
    const { t } = useTranslation();

    return (
        <section className="woman-page__recommendations" aria-labelledby="random-women-title">
            <h2 id="random-women-title" className="woman-page__block-title">
                {t("profile.otherWomen")}
            </h2>

            {loading ? (
                <p className="woman-page__empty">{t("profile.loading")}</p>
            ) : women.length > 0 ? (
                <div className="woman-page__recommendations-grid">
                    {women.map((woman) => (
                        <WomanCard
                            key={woman.id}
                            id={woman.id}
                            name={woman.name}
                            surname={woman.surname}
                            domain={woman.category_name}
                            categoryColor={woman.category_color}
                            image={getWomanThumbImageUrl(woman.image)}
                        />
                    ))}
                </div>
            ) : (
                <p className="woman-page__empty">{t("profile.noRandom")}</p>
            )}
        </section>
    );
}

export default RandomWomenSection;
